import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getExtricationSelector } from '../selectors'
import { setAddToTimeLine } from '../store/extrication.actions'
import { ExtricationConstants } from '../store/extrication.constants'
import { IExtricationState } from '../store/extrication.types'
import { addExtricationItem } from '../../../timeline/store/timeline.actions'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'

export function* saveExtrication() {
  let extricationState: IExtricationState = yield select(getExtricationSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    extricationState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: extricationState,
      actionField: (s) => s.method.name,
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    extricationState = handleNemsisCodeError(error, extricationState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.extricationStateList && pcrDoc.patient?.extricationStateList.length) {
    const index = pcrDoc.patient?.extricationStateList?.findIndex(
      (extrication) => extrication.key === extricationState.key
    )
    if (index !== -1) {
      pcrDoc.patient.extricationStateList[index] = extricationState
    } else {
      pcrDoc.patient?.extricationStateList.push(extricationState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, extricationStateList: [extricationState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addExtricationItem())
  } catch (e) {
    yield put(throwPcrException(`saveExtrication() error: ${e}`))
  }
}

export function* saveExtricationSaga() {
  yield takeLatest(
    [
      ExtricationConstants.SAVE_EXTRICATION,
      ExtricationConstants.SET_DATE,
      ExtricationConstants.SET_TIME,
      ExtricationConstants.SET_DATE_TIME,
      ExtricationConstants.SET_ASSESSED_BY,
      ExtricationConstants.SET_RESPONSE,
      ExtricationConstants.SET_RESPONSE_PNNV,
      ExtricationConstants.SET_PROCEDURE_COMPLICATIONS,
      ExtricationConstants.SET_AUTHORIZATION,
      ExtricationConstants.SET_ATTEMPTS,
      ExtricationConstants.SET_ROLE_PERFORMING,
      ExtricationConstants.SET_ROLE_PERFORMING_PNNV,
      ExtricationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      ExtricationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      ExtricationConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveExtrication
  )
}
